/**
 * タブUI（Vanilla JS） ver1.0.0
 * ES6
 *
 * □機能
 * ・WAI-AREAに対応
 * ・セレクトボックスでの切り替えに対応（タブが多めの時にスマホで便利）
 * ・タブでの切り替え（当たり前）
 *
 * □使い方
 * data-tabui="select" は 必要であれば
 * button は aタグ でも可（その場合 data-tabui-href は href に変更 type="button" は削除）
 *
 */
export default (APP) => {
  /* ターゲット要素 */
  const $html = APP.el.html
  const targets = document.querySelectorAll('[data-timing]')

  /*
   * https://blog.jxck.io/entries/2016-06-25/intersection-observer.html
   */
  const config = {
    root: null,
    rootMargin: '0px 0px',
    threshold: calcThresholds(0)
  }

  /**
   * thresholdのステップを計算
   */
  function calcThresholds (numSteps) {
    const thresholds = []

    for (let i = 1.0; i <= numSteps; i++) {
      var ratio = i / numSteps
      thresholds.push(ratio)
    }

    thresholds.push(0)
    return thresholds
  }

  /*
   * インスタンス・イベント登録
   */
  const observer = new window.IntersectionObserver(callback, config)
  Array.prototype.forEach.call(targets, $target => {
    observer.observe($target)
  })

  /*
   * 処理：scroll
   */
  function callback (entries, observer) {
    entries.forEach(entry => {
      const $target = entry.target
      processing($target, entry)
    })
  }

  /*
   * ①可視状態の処理
   */
  function processing ($target, entry) {
    /* 関数実行 */
    const fnName = $target.getAttribute('data-timing')

    if (fnName === 'top') {
      if (!entry.isIntersecting) {
        $html.classList.add('timimg-over-top')
      } else {
        $html.classList.remove('timimg-over-top')
      }
    } else if (fnName === 'bottom') {
      if (entry.isIntersecting) {
        $html.classList.add('timimg-view-bottom')
      } else {
        $html.classList.remove('timimg-view-bottom')
      }
    }
  }
}
